import NrIcon from '../NrIcon';
import OPagination from '@oruga-ui/oruga-next/src/components/pagination/Pagination.vue';
import OPaginationButton from '@oruga-ui/oruga-next/src/components/pagination/PaginationButton.vue';
export default {
  name: 'NrPagination',
  components: {
    OPagination: OPagination,
    OPaginationButton: OPaginationButton,
    NrIcon: NrIcon
  },
  props: {
    /** Total count of items */
    total: [Number, String],
    /** Items count for each page */
    perPage: {
      type: [Number, String],
      default: 20
    },
    /** Current page number */
    current: {
      type: [Number, String],
      default: 1
    },
    /** Number of pagination items to show before current page */
    rangeBefore: {
      type: [Number, String],
      default: 1
    },
    /** Number of pagination items to show after current page */
    rangeAfter: {
      type: [Number, String],
      default: 1
    },
    /** Simple style */
    simple: Boolean,
    /**
     * Buttons order, optional
     * @values centered, right, left
     */
    order: {
      type: String,
      default: 'left'
    },
    /** Icon to use for previous button */
    iconPrev: {
      type: String,
      default: 'chevron-left'
    },
    /** Icon to use for next button */
    iconNext: {
      type: String,
      default: 'chevron-right'
    },
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String
  },
  methods: {
    onChange: function onChange(val) {
      this.$emit('change', val);
    },
    onUpdate: function onUpdate(val) {
      this.$emit('update', val);
    }
  }
};